module.exports = __webpack_public_path__ + "static/img/newanli-16.85e1fee8.jpg";